// Copyright (c) 2016 Deere & Company

import MaintenancePlan from '@deere/cps-it.warranty-model-factory/lib/maintenance-plan';
import t from 'tcomb';

const MaintenancePlans = t.list(MaintenancePlan, 'MaintenancePlans');

export const getDefaultState = () => new MaintenancePlans([]);

export default MaintenancePlans;



// WEBPACK FOOTER //
// ./src/product/details/state/maintenance-plans.js